import {
  Component,
  computed,
  forwardRef,
  inject,
  signal,
  Signal,
  WritableSignal
} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {IHairstyle} from '../../interfaces/hairstyle.interface';
import {HairstylesService} from '../../services/hairstyles/hairstyles.service';
import {IconSearchComponent} from '../icons/icon-search/icon-search.component';


@Component({
  selector: 'braidsbook-hairstyle-search',
  imports: [IconSearchComponent, FormsModule],
  templateUrl: './hairstyle-search.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HairstyleSearchComponent),
      multi: true
    }
  ]
})
export class HairstyleSearchComponent implements ControlValueAccessor {
  readonly #hairstylesService: HairstylesService = inject(HairstylesService);

  searchTerm: WritableSignal<string> = signal<string>('');
  showResults: WritableSignal<boolean> = signal<boolean>(false);
  noResults: WritableSignal<boolean> = signal<boolean>(false);
  hairstyles: Signal<IHairstyle[]> = this.#hairstylesService.hairstyles;
  filteredHairstyles: Signal<IHairstyle[]> = computed(() => {
    return this.hairstyles().filter((hairstyle: IHairstyle) => {
      return this.searchTerm().length > 0 && hairstyle.nom.toLowerCase().includes(this.searchTerm().toLowerCase());
    });
  });

  handleFocus(): void {
    if (this.searchTerm().length > 0) {
      this.showResults.set(true);
    }
  }

  handleBlur() {
    setTimeout(() => {
      this.showResults.set(false);
    }, 200);
  }

  handleSearch(): void {
    this.onChange(this.searchTerm());
    this.showResults.set(this.searchTerm().length > 0);
    this.noResults.set(this.showResults() && this.filteredHairstyles().length === 0);
  }

  handleSelectHairstyle(hairstyleName: string): void {
    this.searchTerm.set(hairstyleName);
    this.showResults.set(false);
    this.onChange(hairstyleName);
    this.onTouched();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    this.searchTerm.set(obj);
  }

  private onChange: (value: string) => void = () => {
  };
  private onTouched: () => void = () => {
  };

}
